<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
				
				<Row>
					<Col>
						<FormItem label="名称" prop="name" class="">
							<Input v-model="formValidate.name" placeholder="请输入名称"></Input>
						</FormItem>
					</Col>
				</Row>
				<Row>
					<Col>
						<FormItem label="简介" prop="intro" class="">
							<Input v-model="formValidate.intro" type="textarea" :autosize="{minRows: 5,maxRows: 5}" placeholder="请输入简介"></Input>
						</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span="8">
						<FormItem label="设备类型" prop="macTypeId" class="">
							<Select v-model="formValidate.macTypeId" placeholder="请选择设备类型">
								<Option v-for="item in macType" :key="item.id"  :value="item.id" >{{item.name}}</Option>
							</Select>
						</FormItem>
					</Col>
					<Col span="8">
						<FormItem label="出货口类型" prop="holeType" class="">
							<Select v-model="formValidate.holeType" placeholder="请选择">
								<Option value="1">一个出货口</Option>
								<Option value="2">两个出货口</Option>
							</Select>
						</FormItem>
					</Col>
					
				</Row>
				<Row>
					<Col span="8">
						<FormItem label="长度" prop="lenght" class="">
							<Input v-model="formValidate.lenght" placeholder="请输入长度(单位:cm)"></Input>
						</FormItem>
					</Col>
					<Col span="8">
						<FormItem label="宽度" prop="width" class="">
							<Input v-model="formValidate.width" placeholder="请输入宽度(单位:cm)"></Input>
						</FormItem>
					</Col>
					<Col span="8">
						<FormItem label="高度" prop="height" class="">
							<Input v-model="formValidate.height" placeholder="请输入高度(单位:cm)"></Input>
						</FormItem>
					</Col>
					
				</Row>
				<Row>
					<Col span="8">
						<FormItem label="重量" prop="weight" class="">
							<Input v-model="formValidate.weight" placeholder="请输入重量(单位:kg)"></Input>
						</FormItem>
					</Col>
					<Col span="8">
						<FormItem label="最大存储量" prop="maxCommodityNumber" class="">
							<Input v-model="formValidate.maxCommodityNumber" placeholder="请输入最大商品存储量"></Input>
						</FormItem>
					</Col>
					<Col span="8">
						<FormItem label="最大种类" prop="maxTypeNumber" class="">
							<Input v-model="formValidate.maxTypeNumber" placeholder="请输入最大商品种类数"></Input>
						</FormItem>
					</Col>
					
					
				</Row>
				
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				macType:[],
				formValidate: {
					name: '',
					intro: '',
					macTypeId:'',
					model: '',
					lenght: '',
					width: '',
					height: '',
					weight: '',
					maxCommodityNumber: '',
					maxTypeNumber: '',
					isRefrigerate: 'true',
					temperature: '',
					state:'true',
					holeType:'1'
				},
				ruleValidate: {
					name: [{
						required: true,
						message: '名称不能为空！！！',
						trigger: 'blur'
					}],
					intro: [{
						required: true,
						message: '简介不能为空！！！',
						trigger: 'blur'
					}],
					
					lenght: [{
						required: true,
						message: '长度不能为空！！！',
						trigger: 'blur',
					}],
					width: [{
						required: true,
						message: '宽度不能为空！！！',
						trigger: 'blur',
					}],
					height: [{
						required: true,
						message: '高度不能为空！！！',
						trigger: 'blur',
					}],
					weight: [{
						required: true,
						message: '重量不能为空！！！',
						trigger: 'blur',
					}],
					maxCommodityNumber: [{
						required: true,
						message: '最大商品数不能为空！！！',
						trigger: 'blur',
					}],
					maxTypeNumber: [{
						required: true,
						message: '最大商品种类不能为空！！！',
						trigger: 'blur',
					}],
					macTypeId: [{
						required: true,
						message: '设备类型不能为空！！！',
						trigger: 'blur'
					}],
					holeType: [{
						required: true,
						message: '请选择出货口类型！！！',
						trigger: 'blur'
					}],

				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			handleSubmit(name) {
				let _this=this
				this.$refs[name].validate((valid) => {
					if (valid) {
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/fac/mac/details/add',
						    data: _this.formValidate,
							_this: _this,
							success: function(data) {
								_this.$Message.success('新增成功!');
								_this.$refs[name].resetFields();
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
						
					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			}
		},
		created() { //请求设备类型数据
		    var page={page:0,size:1000,state:true}
			let _this=this
			http.http({
			    //这里是你自己的请求方式、url和data参数
			    method: 'post',
			    url: http.url + '/fac/mac/type/page1',
			    data: page,
				_this: _this,
				success: function(data) {
					_this.macType=data.macTypes.content
					_this.formValidate.macTypeId=_this.macType[0].id
				}
			    //假设后台需要的是表单数据这里你就可以更改
			  })
			
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.content {
		margin-left: 10%;
		width: 900px;

	}

	.ivu-form-item {
		margin-bottom: 5px;
	}
	.ivu-row{
		margin-bottom: 20px;
	}

</style>



// WEBPACK FOOTER //
// src/components/jm/pcoduction/machine/add.vue